export const getAssetImportantLevelOptions = (t) => [
  {
    label: t("policy.asset-importance-level-highest"),
    value: "HIGHEST",
  },
  {
    label: t("policy.asset-importance-level-high"),
    value: "HIGH",
  },
  {
    label: t("policy.asset-importance-level-medium"),
    value: "MEDIUM",
  },
  {
    label: t("policy.asset-importance-level-low"),
    value: "LOW",
  },
]
